export enum FeaturesRoutingEnum {
  Home = '',
  HelpForm = 'helps',
  Dashboard = 'dashboard',
  NotFound = '404',
  Cpu = 'cpu',
  Faq = 'faq',
  DepotForm = 'depot-form',
  Advices = 'advices',
  Beta = 'nme',
  Payment = 'payment',
}
